import React from "react";
import { useTheme } from "../context/ThemeContext";

function Navbar({
  initialDeposit,
  currentBalance,
  handleReset,
  trades,
  isBacktestComplete,
  onCompleteBacktest,
}) {
  const { darkMode, toggleDarkMode } = useTheme();

  return (
    <div
      className={`fixed top-0 left-0 right-0 shadow-md z-50 ${
        darkMode ? "bg-gray-800" : "bg-white"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center space-x-3">
            <img
              src="/logo.png"
              alt="RamiForex Logo"
              className="w-8 h-8 object-contain"
            />
            <h1
              className={`text-xl font-bold ${
                darkMode ? "text-white" : "text-gray-800"
              }`}
            >
              RamiForex Backtest
            </h1>
          </div>
          <div className="flex items-center space-x-6">
            <div
              className={`text-sm ${
                darkMode ? "text-gray-300" : "text-gray-500"
              }`}
            >
              <span>Initial Deposit:</span>
              <span
                className={`ml-2 font-semibold ${
                  darkMode ? "text-white" : "text-gray-900"
                }`}
              >
                ${initialDeposit.toFixed(2)}
              </span>
            </div>
            <div
              className={`text-sm ${
                darkMode ? "text-gray-300" : "text-gray-500"
              }`}
            >
              <span>Current Balance:</span>
              <span
                className={`ml-2 font-semibold ${
                  currentBalance > initialDeposit
                    ? "text-green-500"
                    : currentBalance < initialDeposit
                    ? "text-red-500"
                    : darkMode
                    ? "text-white"
                    : "text-gray-900"
                }`}
              >
                ${currentBalance.toFixed(2)}
              </span>
            </div>
            <button
              onClick={toggleDarkMode}
              className={`p-2 rounded-lg ${
                darkMode
                  ? "bg-gray-700 text-yellow-400 hover:bg-gray-600"
                  : "bg-gray-100 text-gray-600 hover:bg-gray-200"
              }`}
              aria-label="Toggle dark mode"
            >
              {darkMode ? (
                <svg
                  className="w-5 h-5"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"
                  />
                </svg>
              ) : (
                <svg
                  className="w-5 h-5"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"
                  />
                </svg>
              )}
            </button>
            {trades.length > 0 && !isBacktestComplete && (
              <button
                onClick={onCompleteBacktest}
                className={`px-4 py-2 rounded text-white text-sm font-medium transition-colors duration-150 ${
                  darkMode
                    ? "bg-green-600 hover:bg-green-700"
                    : "bg-green-500 hover:bg-green-600"
                }`}
              >
                Complete Backtest
              </button>
            )}
            <button
              onClick={handleReset}
              className={`px-4 py-2 rounded text-white text-sm font-medium transition-colors duration-150 ${
                darkMode
                  ? "bg-red-600 hover:bg-red-700"
                  : "bg-red-500 hover:bg-red-600"
              }`}
            >
              Reset Backtest
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Navbar;
